<template>
    <section class="payment">
        <div class="container">
            <p class="h3 form__success" v-if="success">
                <img class="form__success-img" src="/assets/img/other/snail.png" alt="">
                <span class="form__success-text">
                        Заявка успешно отправлена! Мы свяжемся с Вами в ближайшее время.
                    </span>
            </p>
            <form class="form" v-if="!success" @submit.prevent="formSubmit">
                <input-text v-model="payment.name"
                            :v="$v.payment.name"
                            placeholder="Имя*"
                            errorText="Укажите имя"/>
                <input-text v-model="payment.last_name"
                            :v="$v.payment.last_name"
                            placeholder="Фамилия*"
                            errorText="Укажите фамилию"/>
                <div class="input">
                    <v-select :options="cities"
                              :multiple="false"
                              :searchable="false"
                              v-model="payment.city"
                              @change="$v.payment.city.$touch()"
                              @blur="$v.payment.city.$touch()"
                              required
                              placeholder="Укажите область*">
                    </v-select>
                    <span class="input__error" v-if="$v.payment.city.$error">Укажите область</span>
                </div>
                <input-phone v-model="payment.phone"
                             :v="$v.payment.phone"
                             errorText="Укажите корректный номер"
                             placeholder="Телефон*"/>
                <input-email v-model="payment.email"
                             :v="$v.payment.email"
                             errorText="Укажите корректный email"
                             placeholder="Email*"/>
                <input-text v-model="payment.amount"
                            :v="$v.payment.amount"
                            type="number"
                            placeholder="Сумма*"
                            errorText="Укажите сумму"/>
                <customTextarea v-model="payment.comment"
                                :v="$v.payment.comment"
                                placeholder="Адрес объекта"/>
                <custom-checkbox
                    :v="$v.payment.politics"
                    v-model="payment.politics"
                    :class="{_error: $v.payment.politics.$error}"
                    checkboxName="politicsPayment"
                    checkboxText="Отправляя форму, Вы даёте согласие на обработку персональных данных"/>

                <button class="btn" type="submit">Оплатить</button>
            </form>
        </div>
    </section>
</template>

<script>
import customTextarea from "./common/customTextarea";
import customCheckbox from './common/custom-checkbox';
import inputText from "./common/inputText";
import inputEmail from "./common/inputEmail";
import inputPhone from "./common/inputPhone";
import {maxLength, minLength, required, sameAs, numeric, email} from "vuelidate/lib/validators";

export default {
    name: 'paymentForm',
    components: {inputText, inputEmail, inputPhone, customCheckbox, customTextarea},
    created() {
        if(this.$route.path === '/success' &&this.$route.query.orderId) {
            this.$http.post('/api/forms/payments/'+this.$route.query.orderId+'/confirm').then(res => {})
        }
        if(this.$route.path === '/error' && this.$route.query.orderId) {
            this.$http.post('/api/forms/payments/'+this.$route.query.orderId+'/error').then(res => {})
        }
    },
    data() {
        return {
            payment: {
                name: null,
                last_name: null,
                city: null,
                amount: null,
                email: null,
                comment: null,
                recaptcha: null,
                politics: true,
            },
            cities: this.$store.state.cities,
            success: false,
        }
    },
    validations: {
        payment: {
            name: {
                required,
                minLength: minLength(2)
            },
            last_name: {
                required,
                minLength: minLength(2)
            },
            email: {
              required,
              email: true
            },
            city: {required},
            amount: {
                required,
                numeric: true
            },
            comment: {},
            politics: {
                sameAs: sameAs(() => true)
            },
            phone: {
                required,
                minLength: minLength(18),
                maxLength: maxLength(18),
                correctAddress(phone) {
                    return /^((8|\+7)[\- ]?)?(\(?\d{3}\)?[\- ]?)?[\d\- ]{7,10}$/.test(phone)
                }
            }
        }
    },
    methods: {
        formSubmit() {
            this.$v.payment.$touch();
            if (this.$v.payment.$pending || this.$v.payment.$error) {
            } else {
                this.recaptcha().then(token => {
                    this.payment.recaptcha = token;
                    this.$http.post('/api/forms/payments/simple', this.payment).then(res => {
                        window.location = res.data.url;
                    })
                });
            }
        },
    }
}
</script>
